import axios from '../utils/axios';

export default function fetchSeekerVerificationList(adminId, params) {
        return (
            axios.get('/admin/' + adminId + '/jobseeker-admin/v2/admin-recruiter/verificationstatus', { params })
        )   
}
